// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".smart-variable-text-input{display:block}.smart-variable-text-input textarea{max-inline-size:100%;inline-size:100%;display:block;box-sizing:border-box;padding-block:4px;padding-inline:8px}.variable-list{border:1px solid}.variable-option{font-style:italic;display:block;background-color:#fff;border:none}", ""]);
// Exports
module.exports = exports;
